import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { LLMTemplateDetailsState, SLICE_NAME } from './models';

const llmTemplateDetailsSelector = (state: RootState): LLMTemplateDetailsState => state[SLICE_NAME];

export const selectLLMTemplateDetails = createSelector(
  llmTemplateDetailsSelector,
  (state: LLMTemplateDetailsState) => state.template,
);

export const selectLLMTemplateDetailsIsLoading = createSelector(
  llmTemplateDetailsSelector,
  (state: LLMTemplateDetailsState) => state.isLoading,
);

export const selectLLMTemplateDetailsIsSaving = createSelector(
  llmTemplateDetailsSelector,
  (state: LLMTemplateDetailsState) => state.isSaving,
);

export const selectLLMTemplateDetailsError = createSelector(
  llmTemplateDetailsSelector,
  (state: LLMTemplateDetailsState) => state.error,
);
